module.exports = __webpack_public_path__ + "static/media/slideshow_home_3.69399c2e.jpg";